import {UmpireStatisticValues} from '../umpire-statistic-values';
import {UmpireSquadPlayer} from '../umpire-squad-player';

export interface UmpireStatistic {
  type: string;

  id: string;

  resource: UmpireSquadPlayer;

  values: UmpireStatisticValues;
}
